import { render, staticRenderFns } from "./gamerankuser.vue?vue&type=template&id=ef073834&scoped=true"
import script from "./gamerankuser.vue?vue&type=script&lang=js"
export * from "./gamerankuser.vue?vue&type=script&lang=js"
import style0 from "./gamerankuser.vue?vue&type=style&index=0&id=ef073834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef073834",
  null
  
)

export default component.exports